<template>
  <div class="quiz-page">
    <my-breadcrumb :items="pagination"></my-breadcrumb>

    <div class="quiz-integral">
      <h4 class="mt-3">
        {{tryout.name}}
      </h4>
      <div class="bg-white p-4 mt-3">
        <div class="text-left text-md-right p-0 p-md-3">
          <p class="py-3">
            Waktu pengerjaan tryout
          </p>
          <p class="quiz-integral__when d-inline p-2 my-2">
            {{ $helpers.formatDateTimeID(tryout_result.start_time)}}
          </p>
        </div>

        <img
          class="quiz-integral__img mt-5 mt-md-0"
          src="/img/quiz/selamat.png"
        />
        <h2 class="text-center mt-3">
          Review 
        </h2>
        <!-- <p class="text-center quiz-integral__p m-auto">
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
          nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam
        </p> -->

        <tryout-summary class="mt-4" :result="tryout_result"> </tryout-summary>

        <div class="ajustify-center mt-4 pb-5">
          <my-button class="m-2 px-5 btn-font sm-w-100" type="fill-blue" @click="retry">
            <fa-icon class="mr-1" icon="redo-alt"></fa-icon>
            Ulangi Tryout
          </my-button>
          <my-button class="m-2 px-5 btn-font sm-w-100" @click="openAnswer">
            <fa-icon class="mr-1" icon="search"></fa-icon>
            Pembahasan Jawaban
          </my-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyButton from "../components/MyButton.vue";
import TryoutSummary from "../components/TryoutSummary";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  components: { MyButton },
  data: () => ({
  }),
  mounted() {
    this.getResult();
  },
  computed: {
    ...mapGetters({
      tryout_result: types.TRYOUT_RESULT,
      tryout: types.TRYOUT,
    }), 
    pagination() {
      return [
        {
          text: this.tryout.tryout_level,
          url: '#'
        },
        {
          text: this.tryout.name,
          url: '#'
        }
      ]
    }
  },
  components: {
    MyButton,
    TryoutSummary
  },
  methods: {
    ...mapActions({
      geTryoutResult: types.GET_TRYOUT_RESULT
    }),
    getResult() {
      this.geTryoutResult(this.$route.params.result)
      .then(response => {

      }).catch(error => {

      })
    },
    retry() {
      this.$router.push('/tryout/' + this.tryout.id)
    },
    formatDate(strDate) {
      var monthName = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      var date = new Date(strDate);
      var yyyy = date.getFullYear();
      var mm = monthName[date.getMonth()];
      var dd = String(date.getDate()).padStart(2, "0");
      var hh = String(date.getHours()).padStart(2, "0");
      var ii = String(date.getMinutes()).padStart(2, "0");
      var ss = String(date.getSeconds()).padStart(2, "0");

      date = dd + " " + mm + " " + yyyy + " " + hh + ":" + ii + ":" + ss;

      return date;
    },
    openAnswer() {
      this.$helpers.showMessageBox(this, 'Coming Soon', 'Coming Soon', 'success')
    }
  }
};
</script>
<style>
.quiz-integral {
  padding: 22px;
  padding-top: 0;
}

.quiz-integral__p {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.86;
  color: #000000;
  max-width: 477px;
}

.quiz-integral__img {
  width: 85px;
  height: 83.1px;
  margin: auto;
  display: block;
}

.quiz-integral__when {
  color: #ff4e4b;
  background-color: #feedec;
}

.btn-font {
  font-size: 14px;
  font-weight: bold;
}

@media only screen and (max-width: 768px) {
  .quiz-integral {
    padding: 15px;
  }
}
</style>
